// Deaktivierte Fahrer (Portal-Sperre über „Fahrer deaktivieren").
// Das Flag `isActive === false` sperrt den Fahrer beim App-Login aus, wurde
// aber bislang nur in der Fahrerliste ausgewertet — die Auswahllisten der
// Fahrtzuweisung und Schichtplanung boten deaktivierte Fahrer weiter an.

/**
 * True, wenn der Fahrer im Portal deaktiviert wurde.
 * Bewusst auf `=== false` geprüft: Fahrer ohne das Feld gelten als aktiv.
 * @param {object} driver
 * @returns {boolean}
 */
export const isDriverDeactivated = (driver) => driver?.isActive === false;

/**
 * Entfernt deaktivierte Fahrer aus einer Auswahlliste.
 *
 * `keepDriverId` haelt einen bereits zugewiesenen Fahrer in der Liste, auch
 * wenn er inzwischen deaktiviert wurde. Ohne diese Ausnahme fiele er beim
 * Bearbeiten einer alten Fahrt oder Schicht stillschweigend aus dem Feld und
 * das Formular zeigte einen leeren Fahrer an.
 *
 * @param {Array<object>} drivers
 * @param {string|null} [keepDriverId]
 * @returns {Array<object>}
 */
/**
 * Ein Fahrer darf erst geloescht werden, nachdem er deaktiviert wurde.
 * Das Deaktivieren ist der umkehrbare Zwischenschritt: es meldet den Fahrer ab
 * und nimmt ihn aus allen Auswahllisten, laesst die Fahrtenhistorie aber intakt.
 * Die verbindliche Pruefung erfolgt serverseitig in der Cloud Function
 * `deleteDriver`.
 * @param {object} driver
 * @returns {boolean}
 */
export const canDeleteDriver = (driver) => isDriverDeactivated(driver);

/** Begruendung für den gesperrten Löschen-Knopf. */
export const DELETE_REQUIRES_DEACTIVATION_HINT =
  'Fahrer muss zuerst deaktiviert werden.';

export const filterSelectableDrivers = (drivers, keepDriverId = null) =>
  (drivers || []).filter(
    (driver) => !isDriverDeactivated(driver) || (keepDriverId && driver.id === keepDriverId)
  );
